import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { PackPublicContentItem } from "src/app/Services/frontline-ops.service";

export interface PromotePackConfirmDialogData {
  packTitle: string;
  items: PackPublicContentItem[];
  /** request: the author asks to take it public; promote: an approver makes it public now. */
  mode: "request" | "promote";
}

/** Confirms that the organization guides and packs inside a guide pack go public with it. */
@Component({
  selector: "app-promote-pack-confirm-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: "./promote-pack-confirm-dialog.component.html",
  styleUrls: ["./promote-pack-confirm-dialog.component.scss"],
})
export class PromotePackConfirmDialogComponent {
  readonly goingPublic: PackPublicContentItem[];
  readonly alreadyPublic: PackPublicContentItem[];

  constructor(
    public dialogRef: MatDialogRef<PromotePackConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: PromotePackConfirmDialogData
  ) {
    const items = data.items || [];
    this.goingPublic = items.filter((i) => i.status !== "alreadyPublic");
    this.alreadyPublic = items.filter((i) => i.status === "alreadyPublic");
  }

  get guideCount(): number {
    return this.goingPublic.filter((i) => i.kind === "guide").length;
  }

  get confirmLabel(): string {
    const n = this.goingPublic.length;
    if (!n) return this.data.mode === "promote" ? "Promote to public" : "Take to public";
    const what = n === 1 ? "1 item" : `${n} items`;
    return this.data.mode === "promote"
      ? `Promote pack and ${what} to public`
      : `Take pack and ${what} to public`;
  }

  kindIcon(item: PackPublicContentItem): string {
    return item.kind === "pack" ? "collections_bookmark" : "menu_book";
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
